import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const ServersListDetailBox = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: 'flex',
				gap: 50,
				alignItems: 'center',
			},
			sx,
		)}
		{...rest}
	/>
);

export default ServersListDetailBox;
